<template>
  <div class="success-page pcStyle">
    <Header />
    <div class="page-content">
      <img class="icon" src="@/assets/images/success.png" alt="" />
      <div class="title">{{ successTitle }}</div>
      <div class="sub-title">{{ successSubTitle }}</div>
    </div>
  </div>
</template>
<script>
  import Header from '../components/Header.vue';
  export default {
    components: {
      Header,
    },
    data() {
      return {
        time: 5,
        timer: null,
        email: '',
      };
    },
    computed: {
      successTitle() {
        return this.i18n.independentMarketing.successPage.title.replace('$1', this.email);
      },
      successSubTitle() {
        return this.i18n.independentMarketing.successPage.subTitle.replace('$1', this.time);
      },
    },
    created() {
      this.email = this.$route.query?.email;
      this.timer = setInterval(() => {
        this.time--;
        if (this.time === 0) {
          clearInterval(this.timer);
          window.location.href = "https://cloud.autel.com";
        }
      }, 1000);
    },
    beforeDestroy() {
      clearInterval(this.timer);
    },
  };
</script>
<style lang="less" scoped>
.success-page.pcStyle {
  height: 100%;
  box-sizing: border-box;
  text-align: center;
  .page-content {
    padding-top: 10%;
    .icon {
      width: 46px;
      height: 46px;
    }
    .title {
      margin-top: 30px;
      margin-bottom: 82px;
      font-size: 21px;
      color: #303030;
      line-height: 32px;
    }
    .sub-title {
      font-size: 16px;
      color: #555;
    }
  }
}
</style>